import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TravelModalComponent } from '../travel-modal/travel-modal.component';
import { GeneralService } from '../general.service';
import { Observable, catchError, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSelectChange } from '@angular/material/select';
import { DateAdapter } from '@angular/material/core';
import { REGIONS, RELATIONSHIPS } from '../models/create-policy.models';

@Component({
  selector: 'app-create-policy',
  templateUrl: './create-policy.component.html',
  styleUrls: [
    '../dasboard/dasboard.component.css',
    './create-policy.component.css',
  ],
})
export class CreatePolicyComponent implements OnInit, AfterViewInit {
  @ViewChild('passportInput') passportInput!: ElementRef;

  minDate: Date | string;
  minDate2: Date | string;
  file: any;
  startDate: any;
  TravellerCount: number = 0;
  regions = REGIONS;
  relationships = RELATIONSHIPS;
  fileLink: string = '';

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private s: GeneralService,
    private toaster: ToastrService,
    private r: Router,
    private route: ActivatedRoute,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.minDate = new Date();
    this.minDate2 = new Date();
  }
  ngAfterViewInit(): void {
    if (localStorage.getItem('qoute')) {
      this.setQouteValue();
      this.qoute = JSON.parse(localStorage.getItem('qoute')!);
    }
  }
  qoute: any = {};

  trxnId: any;
  persons: any = [];
  initiatorEmail: any;

  ty: { [key: string]: string } = {};
  countriesHldr: any[] = [];
  ngOnInit(): void {
    this.trxnId = Math.floor(Math.random() * 10000000);
    this.s.getPkgs().subscribe((r: any) => {
      this.s.loader = false;
      this.pkgs = r;
      // if (localStorage.getItem('qoute')) {
      //   this.setQouteValue();
      //   this.qoute = true
      // }
    });
    const user = localStorage.getItem('user')
    this.initiatorEmail = JSON.parse(user!).email
    if (this.route.snapshot.params['id']) {
      this.s
        .getPolicyDetails(this.route.snapshot.params['id'])
        .subscribe((r: any) => {
          console.log(r);
          this.trxnId = r['Traveller Info']['sessionId'];
          // country_id
          this.sett.coverage = r['Traveller Info']['coverage'];
          this.policyForm.controls['coverage'].setValue(
            r['Traveller Info']['coverage']
          );
          this.policyForm.controls['coverage'].disable();

          this.sett.payment_plan = r['Traveller Info']['payment_plan'];
          this.sett.payment_plan = this.policyForm.controls[
            'payment_plan'
          ].setValue(r['Traveller Info']['payment_plan']);
          this.policyForm.controls['payment_plan'].disable();

          this.sett.package = r['Traveller Info']['package'];
          this.policyForm.controls['package'].setValue(
            r['Traveller Info']['package']
          );
          this.policyForm.controls['package'].disable();

          this.sett.country_id = r['Traveller Info']['country_id'];
          this.policyForm.controls['country_id'].setValue(
            r['Traveller Info']['country_id']
          );
          this.policyForm.controls['country_id'].disable();

          this.sett.startDate = r['Traveller Info']['startDate'];
          this.policyForm.controls['startDate'].setValue(
            r['Traveller Info']['startDate']
          );
          this.policyForm.controls['startDate'].disable();

          this.sett.endDate = r['Traveller Info']['endDate'];
          this.policyForm.controls['endDate'].setValue(
            r['Traveller Info']['endDate']
          );
          this.policyForm.controls['endDate'].disable();

          this.grossDetail = r['Traveller Info'];
          for (let index = 0; index < r['Users Info'].length; index++) {
            this.persons.push(['Users Info'][index]);
          }
          this.set1();
        });
    }
    this.s
      .getCountries()
      .pipe()
      .subscribe((r: any) => {
        // console.log(r)
        this.s.loader = false;
        this.countries = r;
        this.countriesQueue = r;
        this.countriesHldr = r;
      });
      
  }

  calcNet(val: string) {
    return parseFloat(val) * 0.8;
  }
  calcCommission(val: string) {
    return parseFloat(val) - parseFloat(val) * 0.8;
  }
  btnChkr = false;
  jjs = '';

  noOfDays = 0;
  calcNoDays() {
    let timeDiff =
      new Date(this.policyForm.controls.endDate.value?.toString()!).getTime() -
      new Date(this.policyForm.controls.startDate.value?.toString()!).getTime();
    this.noOfDays = timeDiff / (1000 * 3600 * 24) + 1;
  }

  destination = true;

  onSelection(event: MatSelectChange) {
    if (event.value) {
      this.policyForm.get('country_id')?.enable();
      this.destination = false;
    } else {
      this.policyForm.get('country_id')?.disable();
      this.policyForm.get('country_id')?.setValue(null);
      this.destination = true;
    }
  }

  updateMinEndDate() {
    const startDateValue = this.policyForm.get('startDate')?.value;
    this.policyForm.get('endDate')?.disable();

    if (startDateValue) {
      this.minDate = startDateValue.toString();
      this.getNextDay(startDateValue.toString());
      this.policyForm.get('endDate')?.enable();
    }
  }

  getNextDay(date: Date | string): Date {
    const currentDate = typeof date === 'string' ? new Date(date) : date;
    const nextDay = new Date(currentDate);
    nextDay.setDate(currentDate.getDate() + 1);
    this.minDate = nextDay;
    return nextDay;
  }

  chr(event: any) {
    this.updateMinEndDate();
    this.policyForm.controls.country_id.errors;
    // this.btnChkr =
    //   this.policyForm.controls.country_id.valid &&
    //   this.policyForm.controls.package.valid &&
    //   this.policyForm.controls.startDate.valid &&
    //   this.policyForm.controls.endDate.valid;
  }

  status = false;
  open = true;
  edit = false;
  countries: any[] = [];
  countriesQueue: any[] = [];
  pkgs: any[] = [];
  policyForm = this.fb.group({
    firstname: ['', Validators.required],
    surname: ['', Validators.required],
    othername: [''],
    email: ['', [Validators.required, Validators.email]],
    phone: [
      '',
      [
        Validators.required,
        Validators.compose([
          Validators.maxLength(11),
          Validators.minLength(11),
          Validators.pattern('^[0-9]*$'),
        ]),
      ],
    ],
    dob: [Date, Validators.required],
    // nationality: ['', Validators.required],
    //profession:['', Validators.required],
    // helthstatus: ['', Validators.required],
    // purposeOfTravel: ['', Validators.required],
    passportNo: ['', [Validators.required, Validators.pattern(/[A-Z]{1}\d*$/)]],
    passportIssueDate: [Date, Validators.required],
    passportExpiryDate: [Date, Validators.required],
    passportDataPage:[''],
    gender: ['', Validators.required],
    address: ['', Validators.required],
    startDate: [Date, Validators.required],
    endDate: [Date, Validators.required],
    country_id: [{ value: '', disabled: true }, Validators.required],
    package: ['', Validators.required],
    nextOfKinName: [''],
    relation: [''],
    relationa: [''],
    region: [''],
    sessionId: [''],
    // numberOfPeople: ['', Validators.required],
    // numberOfMinor: ['', Validators.required],
    initiatorEmail: [''],
    coverage: ['Worldwide_1'],
    payment_plan: ['ECONOMY'],
    categoryName: [''],
  });
  set1() {
    this.open = true;
  }
  set2() {
    this.open = false;
  }
  sett: any = {};

  addNew() {
    // this.policyForm.controls['passportDataPage'].setValue(this.fileLink)
    this.policyForm.controls['sessionId'].setValue(this.trxnId);
    this.policyForm.controls['initiatorEmail'].setValue(this.initiatorEmail);
    this.sett.coverage = this.policyForm.controls['coverage'].value;
    this.policyForm.controls['coverage'].disable();
    this.sett.payment_plan = this.policyForm.controls['payment_plan'].value;
    this.policyForm.controls['payment_plan'].disable();
    this.sett.package = this.policyForm.controls['package'].value;
    this.policyForm.controls['package'].disable();
    this.sett.country_id = this.policyForm.controls['country_id'].value;
    this.policyForm.controls['country_id'].disable();
    this.sett.startDate = this.policyForm.controls['startDate'].value;
    this.policyForm.controls['startDate'].disable();
    this.sett.endDate = this.policyForm.controls['endDate'].value;
    this.policyForm.controls['endDate'].disable();

    if (this.policyForm.controls.relation.value == 'Others')
      this.policyForm.controls.relation.setValue(
        this.policyForm.controls.relationa.value
    );
    
    this.sendSingle(this.policyForm.getRawValue());

    this.policyForm.controls['firstname'].reset();
    this.policyForm.controls['surname'].reset();
    this.policyForm.controls['othername'].reset();
    this.policyForm.controls['email'].reset();
    this.policyForm.controls['phone'].reset();
    this.policyForm.controls['gender'].reset();
    this.policyForm.controls['dob'].reset();
    // this.policyForm.controls['nationality'].reset();
    this.policyForm.controls['passportNo'].reset();
    this.policyForm.controls['passportIssueDate'].reset();
    this.policyForm.controls['passportExpiryDate'].reset();
    // this.policyForm.controls['helthstatus'].reset();
    this.policyForm.controls['address'].reset();
    this.policyForm.controls['nextOfKinName'].reset();
    this.policyForm.controls['relation'].reset();
    this.policyForm.controls['region'].reset();

    this.passportInput.nativeElement.value = '';
    this.file = null; 

    

    this.set2();
    // console.log(this.sett);
    // console.log(this.persons);
    // console.log(this.policyForm.controls['package'].value);
  }
  deleteTr(i: number) {
    this.persons.splice(i);
  }
  grossDetail: { [key: string]: any } = {};
  sendSingle(data: any) {
    console.log(data);

    data['categoryName'] = this.ty['categoryName']
      ? this.ty['categoryName']
      : this.qoute.categoryName;
    //  this is done because angular reduces dates by one day while transferring through httpe
    data['endDate'] = new Date(
      Date.UTC(
        new Date(data.endDate).getFullYear(),
        new Date(data.endDate).getMonth(),
        new Date(data.endDate).getDate()
      )
    );
    data['startDate'] = new Date(
      Date.UTC(
        new Date(data.startDate).getFullYear(),
        new Date(data.startDate).getMonth(),
        new Date(data.startDate).getDate()
      )
    );
    data['dob'] = new Date(
      Date.UTC(
        new Date(data.dob).getFullYear(),
        new Date(data.dob).getMonth(),
        new Date(data.dob).getDate()
      )
    );
    console.log(data);
    this.s.sendSingle(data).subscribe((r: any) => {
      this.s.loader = false;
      console.log(r);
      this.persons.push(r.Policy_Detail.original.travellers);
      this.grossDetail = r.Policy_Detail.original.Gross_Detail;
      this.TravellerCount = r.Policy_Detail.original.count;
    });
  }

  preview() {
    this.policyForm.value['package'] =
      this.policyForm.controls['package'].value;
    this.policyForm.value['country_id'] =
      this.policyForm.controls['country_id'].value;
    this.policyForm.value['startDate'] =
      this.policyForm.controls['startDate'].value;
    this.policyForm.value['endDate'] =
      this.policyForm.controls['endDate'].value;
    this.persons.push(this.policyForm.value);
    let data = this.persons;
    let dialogRef = this.dialog.open(TravelModalComponent, {
      data,
    });
    dialogRef.afterClosed().subscribe((r: any) => {
      if (r.action == 'edit') {
        this.edit = true;
        this.policyForm.controls.surname.setValue(data[0].firstname);
        this.set2();
      }
      // if(r.category == "Processing" && r.action){
      //   // send for approval
      // }
    });
    // if(edit){

    // }
  }
  paymentInfo: { [key: string]: string } = {};
  deleteE(id: string, i: number) {
    this.s.deletee(id).subscribe((r) => {
      this.s.loader = false;
      this.grossDetail['grossPremium'] = r['message']['grossPremium'];
      for (let index = 0; index < this.persons.length; index++) {
        if (this.persons[index]._id == id) {
          this.persons.splice(i);
        }
      }
      this.toaster.success('successfully deleted traveler');
    });
  }
  makePyt() {
    let data = {
      amount: this.grossDetail['grossPremium'],
      policy_detail_id: this.grossDetail['_id'],
      type: 'cash',
    };
    let dialogRef = this.dialog.open(TravelModalComponent, {
      data,
    });
    dialogRef.afterClosed().subscribe((r: any) => {
      if (r.action == 'success') {
        this.toaster.success('successfully purchased a policy.');
        let u = JSON.parse(localStorage.getItem('user')!);
        u['certificate_count'] =
          parseInt(u['certificate_count']) + this.persons.length;
        localStorage.setItem('user', JSON.stringify(u));
        this.r.navigateByUrl('main/policy-details/' + this.grossDetail['_id']);
      }
    });
  }
  PLANS = ['PREMIUM', 'CLASSIC', 'ECONOMY'];
  student = false;

  getCountry() {
    this.student = false;
    this.countries = this.countriesHldr;
    let y = this.policyForm.controls.package.value!.toString();
    if (y == '64ec9e085cad90e3a3093572') {
      // student check
      this.jjs = y;
      this.student = true;
      this.countries = this.countriesHldr;
    } else if (
      y == '65328128ed296232df0da66e' ||
      y == '6532830a2a5f686840013eb9'
    ) {
      this.s.getCountries(y).subscribe((r: any) => {
        this.s.loader = false;
        this.countries = r.countries;
        this.countriesQueue = r.countries;
      });
    }
    for (let index = 0; index < this.pkgs.length; index++) {
      if (this.pkgs[index]['_id'] == y) this.ty = this.pkgs[index];
    }
  }

  searchInput(input: string) {
    // this.bRanches = [];
    // country.countryName
    if (input.toLowerCase().length == 0) {
      this.countriesQueue = this.countries;
      return;
    } else {
      this.countriesQueue = [];
    }
    for (let index = 0; index < this.countries.length; index++) {
      if (
        this.countries[index]['countryName']
          .toLowerCase()
          .includes(input.toLowerCase())
      ) {
        // this.countriesQueue

        this.countriesQueue.push(this.countries[index]);
      }
    }
  }

  chrsd() {
    this.btnChkr =
      this.policyForm.controls.country_id.valid &&
      this.policyForm.controls.package.valid &&
      this.policyForm.controls.startDate.valid &&
      this.policyForm.controls.endDate.valid;
      
    this.chr('md');
    this.calcNoDays();
    if (this.jjs == '64ec9e085cad90e3a3093572') {
      this.dataChkr(
        this.policyForm.value['startDate'],
        this.policyForm.value['endDate']
      );
    }
  }

  dataChkr(start: any, end: any) {
    console.log(end, 'ened');
    let timeDiff = new Date(end).getTime() - new Date(start).getTime();
    // console.log(timeDiff / (1000 * 3600 * 24))

    //  console.log(this.policyForm.controls.endDate.value)
    if (timeDiff / (1000 * 3600 * 24) < 180) {
      this.toaster.error('Duration must be more than 180 days');
    }
  }
  getDestination() {
    this.status = !this.status;
    this.s
      .getDestination(this.grossDetail['country_id'])
      .subscribe((r: any) => {
        this.grossDetail['countryName'] = r.countryName;
      });

    localStorage.setItem('travellerCount', this.TravellerCount.toString());
  }
  agee(DOB: any) {
    return new Date().getFullYear() - new Date(DOB).getFullYear();
  }
  setQouteValue() {
    let qoute = JSON.parse(localStorage.getItem('qoute')!);
    this.policyForm.controls.endDate.setValue(qoute.endDate);
    this.policyForm.controls.startDate.setValue(qoute.startDate);
    this.policyForm.controls.package.setValue(qoute.categoryName);
    this.policyForm.controls.package.setValue(qoute.packageName);
    this.policyForm.controls.country_id.setValue(qoute.countryId);
    this.policyForm.controls.dob.setValue(qoute.DOB);
    this.btnChkr = true;
  }

  passportImage(event: any) {
    this.file = event.target.files[0];
    let formData = new FormData();
    formData.append('file', this.file);

    this.s.uploadPassport(formData).subscribe((r: any) => {
      this.s.loader = false;
      this.toaster.success('Passport uploaded successfully');
      this.fileLink = r['imageUrl'];
      this.policyForm.controls['passportDataPage'].setValue(this.fileLink);
    })
  }
}


